// extracted by mini-css-extract-plugin
export default {"CollapsibleComponent":"Collapsible_CollapsibleComponent__tb6gK","gray":"Collapsible_gray__MWjdv","blue":"Collapsible_blue__LlPfe","green":"Collapsible_green__uV3To"};